import { Title as c } from "../EditPanel/Title";
import { conLanding } from "../Models/Landing";

export default class Title extends c {
    con = conLanding();
    getDataSave2 = (): any => {
        const a = this.getDataSave();
        return { ...a, ...this.props.props };
    }
}